import { Carousel } from 'bootstrap';
import { forceDisposeBootstrapCarousel } from './dispose-bootstrap-carousel';
import { ClusterGallerySwiperWidget } from '../widgets/cluster-gallery-swiper-widget';
import { ClusterResidentsSwiperWidget } from '../widgets/cluster-residents-swiper-widget';
import { ClusterBuildingTimelineDragWidget } from '../widgets/cluster-building-timeline-drag-widget';
import { getClusterResidentModal } from '../widgets/resident-modal-widget';

const CONGRESS_CAROUSEL_OPTS = { ride: false, pause: false };

export interface ClusterAboutOperatingCarouselIds {
  galleryRootId: string;
  gallerySourceId: string;
  residentsRootId: string;
  residentsSourceId: string;
}

const instances = new WeakMap<HTMLElement, ClusterResidentsSwiperWidget>();

export function initClusterAboutOperatingCarousels(
  ids: ClusterAboutOperatingCarouselIds,
): ClusterResidentsSwiperWidget | null {
  const galleryRoot = document.getElementById(ids.galleryRootId);
  const gallerySource = document.getElementById(ids.gallerySourceId);

  if (!(galleryRoot instanceof HTMLElement) || !(gallerySource instanceof HTMLElement)) {
    return null;
  }

  // Уничтожаем предыдущий экземпляр для этого root
  instances.get(galleryRoot)?.destroy();

  const widget = new ClusterResidentsSwiperWidget(galleryRoot, gallerySource);

  instances.set(galleryRoot, widget);

  widget.init();

  return widget;
}

export function initClusterDetailGalleryCarousel(rootId: string, sourceId: string): void {
  const galleryRoot = document.getElementById(rootId);
  const gallerySource = document.getElementById(sourceId);
  if (!galleryRoot || !gallerySource) return;

  const galleryWidget = new ClusterGallerySwiperWidget(galleryRoot, gallerySource);
  galleryWidget.init();
}

const residentModalWidget = getClusterResidentModal();

export function initClusterPanelCarousels(panel: HTMLElement): () => void {
  const destroyFns: Array<() => void> = [];

  const residentsRoot = panel.querySelector<HTMLElement>('[id$="ResidentsCarousel"]');
  const residentsSource = panel.querySelector<HTMLElement>('[id$="ResidentsSource"]');

  const galleryRoot = panel.querySelector<HTMLElement>('[id$="GalleryCarousel"]');
  const gallerySource = panel.querySelector<HTMLElement>('[id$="GallerySource"]');
  if (galleryRoot && gallerySource) {
    const w = new ClusterGallerySwiperWidget(galleryRoot, gallerySource);
    w.init();
    destroyFns.push(() => w.destroy());
  }

  if (residentsRoot && residentsSource) {
    const w = new ClusterResidentsSwiperWidget(residentsRoot, residentsSource, () =>
      residentModalWidget.init(),
    );
    w.init();
    destroyFns.push(() => w.destroy());
  }

  panel.querySelectorAll<HTMLElement>('[data-cluster-building-timeline]').forEach((root) => {
    const w = new ClusterBuildingTimelineDragWidget(root);
    w.init();
    destroyFns.push(() => w.destroy());
  });

  const congressRoots = Array.from(
    panel.querySelectorAll<HTMLElement>(
      '.cluster-congress .carousel, .cluster-card-slider .carousel',
    ),
  );
  congressRoots.forEach((root) => {
    forceDisposeBootstrapCarousel(root);
    Carousel.getOrCreateInstance(root, CONGRESS_CAROUSEL_OPTS);
  });

  return () => {
    destroyFns.forEach((fn) => fn());
    congressRoots.forEach((root) => Carousel.getInstance(root)?.pause());
  };
}

export function initClusterCardSliders(scope: ParentNode = document): void {
  scope.querySelectorAll<HTMLElement>('.cluster-card-slider .carousel').forEach((root) => {
    forceDisposeBootstrapCarousel(root);
    Carousel.getOrCreateInstance(root, CONGRESS_CAROUSEL_OPTS);
  });
}
